import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, Chip, Grid, IconButton, Menu, MenuItem, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import AddNewMemberGroup from "./GroupAddNewMember";
import EditGroup from "./GroupEdit";
import AddGroup from "./GroupAdd";
import { Add, ExpandLess, ExpandMore } from "@mui/icons-material";
import ActionButton from "src/components/ActionButton";
import CustomLink from "src/careflow/common/CustomLink";
import { PatientWrapper, WrappedPatient } from "src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient";
import useTenantConfigData from "src/careflow/ph-core/multi-tenant/tenant/hook/useTenantConfigData";
import { useDialogStore } from "src/stores/dialog";
import { useGroups } from "src/careflow/ph-core/fhir-client/fhir-react";
import { useMemo, useState } from "react";
import { GridRowId } from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";
import { isEmpty } from "lodash";
import useLocales from "src/careflow/ph-core/internationalization/hook/useLocales";
import { checkAclValidation } from "src/careflow/ph-core/admin/permissions/util/permission.utils";
import crsAcls from "src/careflow/ph-core/admin/permissions/util/crs/crsAcls";
import CheckIcon from '@mui/icons-material/Check';
import { PATH_DASHBOARD } from "src/routes/paths";
import { getAgeYearsAndMonths } from "src/utils/formatTime";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useSnackbar } from 'notistack';
import Label from 'src/components/Label';

type Props = {
  patient: WrappedPatient;
  PATH_PERMISIONS: string;
};

export default function GroupsList({ patient, PATH_PERMISIONS }: Props){

  const { configurations } = useTenantConfigData();
  const { confirmDialog } = useDialogStore();
  const { enqueueSnackbar } = useSnackbar();
  const { i18n } = useLocales();
  const [updatingStatusGroupId, setUpdatingStatusGroupId] = useState<string | null>(null);

  const [groups, { remove, refresh, update }] = useGroups({
    filter: { member: `${patient?.id}`, _include: 'Group:member' },
  });
  const groupsRows = useMemo(() => separarRespuestas(groups), [groups]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openAddGroup, setAddGroup] = useState(false);
  const [idGroup, setIdGroup] = useState('');
  const [openEditGroup, setEditGroup] = useState(false);
  const [openAddNewMemberGroup, setAddNewMemberGroup] = useState(false);
  const [anchorElSub, setAnchorElSub] = useState(null);
  const [idGroupMember, setIdGroupMember] = useState('');
  const [anchorElMember, setAnchorElMember] = useState<null | HTMLElement>(null);
  const openElMember = Boolean(anchorElMember);
  const [openRows, setOpenRows] = useState<GridRowId[]>([]);

  const handleCloseEditGroup = () => {
    setEditGroup(false);
  };
  const handleCloseAddNewMemberGroup = () => {
    setAddNewMemberGroup(false);
  };
  
  const useStyles = makeStyles({
    content: {
      margin: 0,
    },
  });
  const classes: any = useStyles();
  const handleOptionClick = (option: any) => {
    handleMenuClose();
  };
  const handleCloseAddGroup = () => {
    setAddGroup(false);
  };
  
  const handleMenuClose = () => {
    setAnchorEl(null);
    setAnchorElSub(null);
  };
  const handleClickElMember = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMember(event.currentTarget);
  };
  const handleCloseElMember = () => {
    setAnchorElMember(null);
  };
  const removeGroup = async (groupId?: string) => {
    const targetId = groupId ?? idGroup;
    const group = groups.filter((g) => g.id === targetId);
    try {
      remove(group);
    } catch {}
  };

  const toggleGroupStatus = async (groupId: string, newActiveStatus: boolean) => {
    const group = groups?.find((item: any) => item?.id === groupId);
    if (!group || updatingStatusGroupId === groupId) return;

    setUpdatingStatusGroupId(groupId);
    try {
      const updatedGroup = {
        ...group,
        active: newActiveStatus,
        resourceType: 'Group' as const,
      };
      await update(updatedGroup);
      refresh();
      handleMenuClose();
      enqueueSnackbar(
        newActiveStatus
          ? i18n('patients.details.groups.msgActivate', 'crs') || 'Group activated successfully'
          : i18n('patients.details.groups.msgDeactivate', 'crs') || 'Group deactivated successfully',
        { variant: 'success' }
      );
    } catch {
      enqueueSnackbar(
        i18n('patients.details.groups.msgStatusError', 'crs') || 'Failed to update group status',
        { variant: 'error' }
      );
    } finally {
      setUpdatingStatusGroupId(null);
    }
  };

  const rows = useMemo(
    () =>
      groupsRows?.map((item: any) => {
        const { id, name, member, type, code, managingEntity, identifier, patients, active } = item;
        const codeDisplayMap = code?.coding?.map((val: any) => val?.display);
        return {
          id: id || '',
          name: name || '',
          members: member?.length || 0,
          type: type || '',
          code: codeDisplayMap || '',
          identifier: identifier?.[0]?.value || '',
          patients: patients,
          active: active || false
        };
      }),
    [groupsRows]
  );

  const handleSubMenuOpen = (event: any) => {
    setAnchorElSub(event.currentTarget);
  };
  const dateTimeTransForm = (date: any) => {
    {
      let targetDate = new Date('2023-07-31T07:00:00.000Z');

      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      let monthShort = months[targetDate.getMonth()];

      let year = targetDate.getFullYear();

      let result = `${monthShort} ${year}`;

      return result;
    }
  };
  function separarRespuestas(respuestas: any) {
    const grupos: any = [];
    const patients: any = [];
    respuestas.forEach((respuesta: any) => {
      if (respuesta.resourceType === 'Patient') {
        patients.push(respuesta);
      }
    });

    respuestas.forEach((respuesta: any) => {
      if (respuesta.resourceType === 'Group') {
        const grupo: any = {
          ...respuesta,
          patients: [],
        };
        function quitarPrefijoPatient(reference: string) {
          if (reference.startsWith('Patient/')) {
            return reference.slice(8);
          }
          return reference;
        }
        patients?.forEach((patient: any) => {
          respuesta?.member?.forEach((member: any) => {
            if (patient.id == quitarPrefijoPatient(member.entity.reference)) {
              patient.period = [member?.period];
              const wrappedPatient: WrappedPatient | any = PatientWrapper(patient);
              grupo.patients.push(wrappedPatient);
            }
          });
        });
        grupos.push(grupo);
      }
    });
    return grupos;
  }

  const removeMember = async () => {
    const group = groups?.find((item) => item?.id === idGroup);
    const members: any = group?.member?.filter(
      (item) => item?.entity?.reference !== `Patient/${idGroupMember}`
    );

    const confirmed = await confirmDialog({
      title: 'Confirm Delete',
      disabledConfirm: members?.length === 0 ? true : false,
      description: (
        <>
          {members?.length === 0 ? (
            <Typography gutterBottom>
              There must be at least one associate member of the group
            </Typography>
          ) : (
            <Typography gutterBottom>Want to permanently delete the member??</Typography>
          )}
        </>
      ),
    });

    if (confirmed && group) {
      if (!isEmpty(members)) {
        group.member = members;
      } else {
        delete group?.member;
      }
      update(group);
      refresh();
    }
    handleCloseElMember();
  };

  const toggleRow = (id: string) => {
    setOpenRows((openRows) => {
      if (openRows.includes(id)) {
        return openRows.filter((openRow) => openRow !== id);
      }
      return [...openRows, id];
    });
  };

  return(
    <Card style={{ boxShadow: 'none', position: 'static' }} sx={{ p: 0, boxShadow: 'none' }}>
      <Stack sx={{ m: 1 }}>
        <Grid container display={'flex'} alignItems={'center'} paddingRight={2}>
          {checkAclValidation({ acls: [crsAcls.CRS[PATH_PERMISIONS].GROUPS.ADD] }) && (
            <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
              <Button
                variant="contained"
                size="small"
                sx={{ height: '36px' }}
                startIcon={<Add />}
                onClick={() => setAddGroup(true)}
                style={{ position: 'absolute', top: '25px', right: '25px' }}
              >
                {i18n('patients.details.groups.button', 'crs')}
              </Button>
            </Grid>
          )}
        </Grid>
      </Stack>
      <Paper>
        <Table>
          <TableHead>
            <TableRow style={{ display: 'flex', justifyContent: 'space-around' }}>
              <TableCell align="left" style={{ width: '5%' }}></TableCell>
              <TableCell align="left" style={{ width: '27%' }}>
                {i18n('patients.details.groups.name', 'crs')}
              </TableCell>
              <TableCell align="left" style={{ width: '13%' }}>
                {i18n('patients.details.groups.members', 'crs')}
              </TableCell>
              <TableCell align="left" style={{ width: '13%' }}>
                {i18n('patients.details.groups.type', 'crs')}
              </TableCell>
              <TableCell align="left" style={{ width: '13%' }}>
                {i18n('patients.details.groups.code', 'crs')}
              </TableCell>
              <TableCell align="left" style={{ width: '18%' }}>
                {i18n('patients.details.groups.identifier', 'crs')}
              </TableCell>
              <TableCell align="left" style={{ width: '10%' }}>
                {i18n('patients.details.groups.status', 'crs') || 'Status'}
              </TableCell>
              <TableCell align="center" style={{ width: '5%', minWidth: 48 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row: any, index: any) => (
              <TableRow style={{ width: '100%' }} key={index}>
                <TableCell colSpan={8} style={{ padding: 0 }}>
                  <Accordion
                    expanded={openRows.includes(row?.id)}
                    onChange={() => {}}
                  >
                    <AccordionSummary
                      expandIcon={null}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={{ padding: 0 }}
                      classes={{
                        content: classes.content,
                      }}
                    >
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-around',
                        }}
                      >
                        <TableCell align="left" scope="row" style={{ width: '5%' }} onClick={(e) => e.stopPropagation()}>
                          <IconButton
                            size="small"
                            onClick={() => toggleRow(row?.id)}
                            sx={{ padding: 0 }}
                            aria-label={openRows.includes(row?.id) ? 'Collapse row' : 'Expand row'}
                          >
                            {openRows.includes(row?.id) ? <ExpandLess /> : <ExpandMore />}
                          </IconButton>
                        </TableCell>

                        <TableCell scope="row" align="left" style={{ width: '27%' }}>
                          {row.name}
                        </TableCell>
                        <TableCell scope="row" align="left" style={{ width: '13%' }}>
                          {row.members}
                        </TableCell>
                        <TableCell scope="row" align="left" style={{ width: '13%' }}>
                          {row.type}
                        </TableCell>
                        <TableCell scope="row" align="left" style={{ width: '13%' }}>
                          {!isEmpty(row?.code) &&
                            row?.code?.map((code: any) => (
                              <Chip
                                clickable={false}
                                size="small"
                                key={index}
                                label={code}
                                sx={{ m: 0.2 }}
                              />
                            ))}
                        </TableCell>
                        <TableCell scope="row" align="left" style={{ width: '18%' }}>
                          {row.identifier}
                        </TableCell>
                        <TableCell scope="row" align="left" style={{ width: '10%' }}>
                          <Label color={row?.active ? 'success' : 'error'}>
                            {row?.active
                              ? (i18n('patients.details.groups.statusActive', 'crs') || 'Active')
                              : (i18n('patients.details.groups.statusInactive', 'crs') || 'Inactive')}
                          </Label>
                        </TableCell>
                        <TableCell scope="row" align="center" style={{ width: '5%', minWidth: 48, padding: '16px 0px 16px 0px' }}>
                          <ActionButton
                            useCustomButton
                            customButton={(isMenuOpen, setIsMenuOpen, toggleMenu, menuElementRef) => (
                              <IconButton
                                onClick={(e) => {
                                  setIdGroup(row?.id ?? '');
                                  toggleMenu(e);
                                }}
                                ref={menuElementRef}
                                data-name="action-menu-button"
                              >
                                <MoreVertIcon htmlColor="#241f20" />
                              </IconButton>
                            )}
                            renderChildren={(isMenuOpen, setIsMenuOpen) => (
                              <Box>
                                <div tabIndex={-1}>
                                  {checkAclValidation({
                                    acls: [crsAcls.CRS[PATH_PERMISIONS].GROUPS.EDIT],
                                  }) && (
                                    <MenuItem
                                      onClick={() => {
                                        setEditGroup(true);
                                        setIsMenuOpen(false);
                                      }}
                                    >
                                      Edit
                                    </MenuItem>
                                  )}
                                </div>
                                <div tabIndex={-1}>
                                  {checkAclValidation({
                                    acls: [crsAcls.CRS[PATH_PERMISIONS].GROUPS.MEMBERS.ADD],
                                  }) && (
                                    <MenuItem
                                      onClick={() => {
                                        setIdGroup(row?.id);
                                        setAddNewMemberGroup(true);
                                        setIsMenuOpen(false);
                                      }}
                                    >
                                      {i18n('patients.details.groups.buttonAddMember', 'crs')}
                                    </MenuItem>
                                  )}
                                </div>
                                <div tabIndex={-1}>
                                  {checkAclValidation({
                                    acls: [crsAcls.CRS[PATH_PERMISIONS].GROUPS.DELETE],
                                  }) && (
                                    <MenuItem
                                      onClick={async () => {
                                        handleOptionClick('Detalles');
                                        const confirmed = await confirmDialog({
                                          title: 'Confirm Delete',
                                          description: `Want to Permanently delete the Group`
                                        });
                                        setIsMenuOpen(false);
                                        if (confirmed) return removeGroup(row?.id);
                                      }}
                                    >
                                      Delete
                                    </MenuItem>
                                  )}
                                </div>
                                <div tabIndex={-1}>
                                  <MenuItem
                                    id="openStatus"
                                    key="openStatus"
                                    onClick={(event) => handleSubMenuOpen(event)}
                                  >
                                    Status
                                  </MenuItem>
                                  <Menu
                                    anchorEl={anchorElSub}
                                    open={Boolean(anchorElSub)}
                                    onClose={handleMenuClose}
                                    anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
                                    transformOrigin={{ vertical: 'center', horizontal: 'right' }}
                                    PaperProps={{ sx: { mr: 0.5 } }}
                                  >
                                    <MenuItem
                                      onClick={() => {
                                        if (!row?.active) {
                                          toggleGroupStatus(row?.id, true);
                                        } else {
                                          handleMenuClose();
                                        }
                                      }}
                                      disabled={updatingStatusGroupId === row?.id}
                                    >
                                      Active {row?.active && <CheckIcon style={{ margin: '10px' }} />}
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        if (row?.active) {
                                          toggleGroupStatus(row?.id, false);
                                        } else {
                                          handleMenuClose();
                                        }
                                      }}
                                      disabled={updatingStatusGroupId === row?.id}
                                    >
                                      Inactive {!row?.active && <CheckIcon style={{ margin: '10px' }} />}
                                    </MenuItem>
                                  </Menu>
                              </div>
                              </Box>
                            )}
                          />
                        </TableCell>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails style={{ width: '100%' }}>
                      <div style={{ position: 'relative', zIndex: 1 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell
                                component="th"
                                scope="row"
                                align="left"
                                style={{ width: '18%' }}
                              >
                                {i18n('patients.details.groups.mrn', 'crs')}
                              </TableCell>
                              <TableCell align="left" style={{ width: '25%' }}>
                                {i18n('patients.details.groups.fullname', 'crs')}
                              </TableCell>
                              <TableCell align="left" style={{ width: '18%' }}>
                                {i18n('patients.dateOfBirth', 'crs')}
                              </TableCell>
                              <TableCell align="left" style={{ width: '18%' }}>
                                {i18n('patients.details.groups.period', 'crs')}
                              </TableCell>
                              <TableCell align="left" style={{ width: '18%' }}>
                                {i18n('patients.details.groups.age', 'crs')}
                              </TableCell>
                              <TableCell align="left" style={{ width: '5%' }}></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {row?.patients?.map((rowp: any, indexp: any) => (
                              <TableRow key={`detail-${indexp}`}>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  style={{ width: '18%' }}
                                >
                                  {patient?.id !== rowp?.id ? 
                                      <CustomLink 
                                        to={`${PATH_DASHBOARD.crs.patient.details.forId(rowp?.id)}`}
                                        target="_blank"
                                      >
                                        {rowp?.getMRN(configurations?.mpi?.systemMrn)?.value}
                                      </CustomLink> 
                                    : rowp?.getMRN(configurations?.mpi?.systemMrn)?.value 
                                  }
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{ width: '25%', paddingLeft: '16px' }}
                                >
                                  {rowp?.getFullName()}
                                </TableCell>
                                <TableCell align="left" style={{ width: '18%' }}>
                                  {rowp.getBirthDateForDisplay()} ({rowp.getAgeInYears()}{' '}
                                  years)
                                </TableCell>
                                <TableCell align="left" style={{ width: '18%' }}>
                                  {dateTimeTransForm(rowp?.period[0]?.end) || ''} to Current
                                </TableCell>
                                <TableCell align="left" style={{ width: '18%' }}>
                                  {getAgeYearsAndMonths(rowp?.birthDate)}
                                </TableCell>
                                <TableCell scope="row" align="left" style={{ width: '5%' }}>
                                  <div>
                                    <IconButton
                                      onClick={(event) => {
                                        handleClickElMember(event);
                                        setIdGroup(row?.id);
                                        setIdGroupMember(rowp?.id);
                                      }}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                      anchorEl={anchorElMember}
                                      open={openElMember}
                                      onClose={handleCloseElMember}
                                    >
                                      {checkAclValidation({
                                        acls: [crsAcls.CRS.PATIENT.GROUPS.MEMBERS.ADD],
                                      }) && (
                                        <MenuItem
                                          onClick={() => {
                                            setAddNewMemberGroup(true);
                                            handleCloseElMember();
                                          }}
                                        >
                                          {i18n(
                                            'patients.details.groups.buttonAddMember',
                                            'crs'
                                          )}
                                        </MenuItem>
                                      )}
                                      {checkAclValidation({
                                        acls: [crsAcls.CRS[PATH_PERMISIONS].GROUPS.MEMBERS.DELETE],
                                      }) && (
                                        <MenuItem
                                          onClick={() => {
                                            removeMember();
                                            handleCloseElMember();
                                          }}
                                        >
                                          Delete
                                        </MenuItem>
                                      )}
                                    </Menu>
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      <AddGroup patient={patient} open={openAddGroup} onClose={handleCloseAddGroup} />
      <EditGroup
        open={openEditGroup}
        onClose={handleCloseEditGroup}
        id={idGroup}
        refresh={refresh}
      />
      <AddNewMemberGroup
        id={idGroup}
        patient={patient}
        open={openAddNewMemberGroup}
        onClose={handleCloseAddNewMemberGroup}
        PATH_PERMISIONS={PATH_PERMISIONS}
      />
    </Card>
  )
}